import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  merchantList: [],
  merchantListDetails: [],
  entireListOfMerchants: [],
  loginMerchantsList: [],
  selectedMerchatDetails: {
    merchantName: "",
    merchantId: "",
    external_id: "",
    storeCode: "",
    companyName: "",
    merchant_logo: "",
  },
};

export const merchantListSlice = createSlice({
  name: "merchantListSlice",
  initialState,
  reducers: {
    updateMerchantList(state, action) {
      state.merchantList = action.payload.merchantList;
    },
    updateMerchantListDetails(state, action) {
      state.merchantListDetails = action.payload.merchantListDetails;
    },
    updateEntireListOfMerchants(state, action) {
      state.entireListOfMerchants = action.payload.entireListOfMerchants;
    },
    updateLoginMerchantList(state, action) {
      state.loginMerchantsList = action.payload.loginMerchantsList;
    },
    updateSelectedMerchantDetails(state, action) {
      state.selectedMerchatDetails = action.payload.selectedMerchatDetails;
    },
    resetMerchantSlice: (state) => initialState,
  },
});
export const merchantActions = merchantListSlice.actions;
export default merchantListSlice.reducer;
